import { rem, reset, spacing } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  reset.a,
  reset.button,
  css`
    :host {
      align-items: center;
      display: flex;
    }

    :host(:not([disabled]):hover) {
      background: var(--hover-color);
      cursor: pointer;
    }

    :host([flex]) {
      flex: 1;
    }

    :host(:first-child:not(.toc-action--has-icon)) {
      flex: 1;
    }

    :host(.toc-action--has-icon) {
      inline-size: ${rem(40)};
      margin-inline-start: auto;

      .button {
        align-items: center;
        align-self: stretch;
        display: inline-flex;
        justify-content: center;
        padding: 0;
      }
    }

    :host(:last-child.toc-action--has-icon) {
      margin-inline-end: ${spacing(500)};
    }

    :where(.button) {
      color: inherit;
      inline-size: 100%;
      padding: var(--toc-action-button-padding, 0);
      text-align: start;

      :host-context(.sidenav-wrapper-closed):host-context(a-toc[secondary]) & {
        padding: ${spacing(150, 0, 150, 100)};
      }
    }

    :where(.button:focus-within) {
      outline-color: var(--tm-focus-ring-color);
      outline-offset: calc(-1 * var(--tm-focus-ring-width));
      outline-style: var(--tm-focus-ring-style);
      outline-width: var(--tm-focus-ring-width);
    }

    a * {
      pointer-events: none;
    }

    ::slotted(a-icon) {
      color: var(--icon-color);
    }
  `,
];
